import {
  SET_AGENCIES_GRID_SORT_CRITERIA,
  SET_CURRENT_SELECTED_AGENCY,
  SET_AGENCIES_FILTERS,
  RESET_AGENCIES_FILTERS,
  SET_CREDENTIALS_GRID_SORT_CRITERIA,
  SET_PROFILE_FORM_IS_EDITABLE,
  SET_PROFILE_FORM_IS_NOT_EDITABLE,
  FETCH_AGENCIES_LIST,
  SAVE_AGENCIES_LIST,
  SET_AGENCIES_LIST_IS_LOADING,
  SET_AGENCIES_LIST_IS_NOT_LOADING,
  UPDATE_AGENCY_INFO,
  SET_PROFILE_FORM_IS_LOADING,
  SET_PROFILE_FORM_IS_NOT_LOADING,
  FETCH_AGENCY_CREDENTIALS,
  SAVE_AGENCY_CREDENTIALS,
  SET_AGENCIES_CREDENTIALS_LIST_IS_LOADING,
  SET_AGENCIES_CREDENTIALS_LIST_IS_NOT_LOADING,
  SET_CURRENT_SELECTED_CREDENTIAL,
  SET_SHOW_CREDENTIAL_FORM,
  SET_HIDE_CREDENTIAL_FORM,
  SET_CREDENTIAL_FORM_UPDATE_MODE,
  SET_CREDENTIAL_FORM_CREATE_MODE,
  SET_CREDENTIAL_FORM_IS_LOADING,
  SET_CREDENTIAL_FORM_IS_NOT_LOADING,
  FETCH_SAVE_CREDENTIAL,
} from './actionTypes';

export const setGridSortCriteria = sortCriteria => ({
  type: SET_AGENCIES_GRID_SORT_CRITERIA,
  sortCriteria,
});

export const setCredentialsGridSortCriteria = sortCriteria => ({
  type: SET_CREDENTIALS_GRID_SORT_CRITERIA,
  sortCriteria,
});

export const setCurrentSelectedAgencyId = (currentSelectedAgencyId = '') => ({
  type: SET_CURRENT_SELECTED_AGENCY,
  currentSelectedAgencyId,
});

export const setAgenciesFilters = filters => ({
  type: SET_AGENCIES_FILTERS,
  filters,
});

export const cleanAgenciesFilters = () => ({
  type: RESET_AGENCIES_FILTERS,
});

export const setProfileFormIsEditable = () => ({
  type: SET_PROFILE_FORM_IS_EDITABLE,
});

export const setProfileFormIsNotEditable = () => ({
  type: SET_PROFILE_FORM_IS_NOT_EDITABLE,
});

export const setProfileFormIsLoading = () => ({
  type: SET_PROFILE_FORM_IS_LOADING,
});

export const setProfileFormIsNotLoading = () => ({
  type: SET_PROFILE_FORM_IS_NOT_LOADING,
});

export const fetchAgenciesList = () => ({
  type: FETCH_AGENCIES_LIST,
});

export const saveAgenciesList = agencies => ({
  type: SAVE_AGENCIES_LIST,
  agencies,
});

export const setAgenciesListIsLoading = () => ({
  type: SET_AGENCIES_LIST_IS_LOADING,
});

export const setAgenciesListIsNotLoading = () => ({
  type: SET_AGENCIES_LIST_IS_NOT_LOADING,
});

export const updateAgencyInfo = values => ({
  type: UPDATE_AGENCY_INFO,
  values,
});

export const fetchAgencyCredentialsList = () => ({
  type: FETCH_AGENCY_CREDENTIALS,
});

export const saveAgencyCredentialsList = credentials => ({
  type: SAVE_AGENCY_CREDENTIALS,
  credentials,
});

export const setCurrentSelectedCredentialId = (currentSelectedCredentialId = '') => ({
  type: SET_CURRENT_SELECTED_CREDENTIAL,
  currentSelectedCredentialId,
});

export const setAgencyCredentialsListIsLoading = () => ({
  type: SET_AGENCIES_CREDENTIALS_LIST_IS_LOADING,
});

export const setAgencyCredentialsListIsNotLoading = () => ({
  type: SET_AGENCIES_CREDENTIALS_LIST_IS_NOT_LOADING,
});

export const setShowCredentialForm = () => ({
  type: SET_SHOW_CREDENTIAL_FORM,
});

export const setHideCredentialForm = () => ({
  type: SET_HIDE_CREDENTIAL_FORM,
});

export const setCredentialFormIsLoading = () => ({
  type: SET_CREDENTIAL_FORM_IS_LOADING,
});

export const setCredentialFormIsNotLoading = () => ({
  type: SET_CREDENTIAL_FORM_IS_NOT_LOADING,
});

export const setCredentialFormUpdateMode = () => ({
  type: SET_CREDENTIAL_FORM_UPDATE_MODE,
});

export const setCredentialFormCreateMode = () => ({
  type: SET_CREDENTIAL_FORM_CREATE_MODE,
});

export const fetchSaveCredential = values => ({
  type: FETCH_SAVE_CREDENTIAL,
  values,
});
